import { useMemo } from 'react';

/**
 * Custom hook for managing customer photos filter actions
 * @param {Object} filterState - Current filter state
 * @param {Object} filterActions - Filter action functions
 * @returns {Object} Customer photos filter action functions
 */
const useCustomerPhotosFilterActions = (filterState, filterActions) => {
  const customerPhotosFilterActions = useMemo(
    () => ({
      setMaterialFilter: value => {
        const newValue = filterState.materialFilter === value ? '' : value;
        filterActions.setMaterialFilter(newValue);
      },
      setRoomFilter: value => {
        const newValue = filterState.roomFilter === value ? '' : value;
        filterActions.setRoomFilter(newValue);
      },
      toggleColorFilter: color => {
        filterActions.toggleColorFilter(color);
      },
    }),
    [filterState, filterActions]
  );

  return customerPhotosFilterActions;
};

export default useCustomerPhotosFilterActions;
